new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',

        desktop: window.innerWidth <= 991 ? false : true,
    },
    created() {
        addEventListener("resize", (event) => {
            this.desktop = window.innerWidth <= 991 ? false : true;
        });
        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
    },
    methods: {

        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
              this.showOpened = false
        },

        toggleShare(element) {
            element.target.classList.toggle('active');
            element.target.nextElementSibling.classList.toggle('active');
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();
            
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
            const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        },

        // Product Kit
        getInfo(event, id, autoid) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
            .then(res => {
                const actualElement = event.target;
                const kitColorsElements = document.querySelectorAll('[id^="kitcolors"]');
                const numKitColors = kitColorsElements.length;

                for (let index = 0; index < numKitColors; index++) {
                    const kitColorsId = `kitcolors${index}`;

                    if ($(kitColorsId).closest('.js_product_item_kit').siblings('#js-product_addons__product_detail_' + autoid).length) {
                        $(kitColorsId).closest('.js_product_item_kit').siblings('#js-product_addons__product_detail_' + autoid).remove()
                    }
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product-item-kit').querySelector('.is-selected').classList.remove('is-selected');
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = []
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i])
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail_${autoid}_${res.data.id}_${randomNumber}" id="product_item_variation__product_detail_${autoid}_${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="${autoid}" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail_${autoid}_${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', 'js-product_addons__product_detail_' + autoid);
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', '{{ p.id }}');
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>'
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False'
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`)
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            }else if (res.data.addons[i].field_type = "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $(kitColorsId).closest('.itens-for-carousel').append(complements);
                    }
                    $(kitColorsId).closest('.slick-list').height($(kitColorsId).closest('.itens-for-carousel').outerHeight())
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function() {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);  
                    });
                }
            })
            .catch(err => {
                console.log(err)
            })
        }
    },
    mounted() {
        const photoList = document.getElementById("photo-list");
        if (photoList) {
        const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");
                
                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
          if (newValue) {
            document.body.style.overflow = 'hidden';
          } else {
            document.body.style.removeProperty('overflow');
          }
        },
    }
})

$(document).ready(function () {

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        appendArrows: ".product-detail__showcase--controls-slick",
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('.product-detail__related--items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      mobileFirst: true,
      speed: 700,
      vertical: false,
      responsive: [
          {
              breakpoint: 991,
              settings: {
                slidesToShow: 4,
                dots: false,
                arrows: true,
              }
          },
      ]
    })

    if (document.querySelector(".carousel-kit")) {
        const splide = new Splide(".carousel-kit", {
          type: "slide",
          autoplay: false,
          rewind: false,
          arrows: true,
          speed: 800,
          perPage: 1,
          perMove: 1,
          drag: true,
          pauseOnFocus: false,
          height: "auto",
          pagination: true,
          breakpoints: {
            768: {
              drag: false,
            },
          },
        }).mount();
    }
})